/**
 * Theme override. Default follows prefers-color-scheme (dark first); a stored choice sets <html data-theme>.
 * Stored in localStorage as a per-viewer convenience only.
 */
export type ThemeChoice = 'system' | 'dark' | 'light';
const KEY = 'hangar.theme';

export function getThemeChoice(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'dark' || v === 'light' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme;
  else root.dataset.theme = choice;
}

export function setThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    /* storage unavailable: the choice still applies for this page */
  }
  applyTheme(choice);
}

export function applyStoredTheme(): void {
  applyTheme(getThemeChoice());
}
